import { render, staticRenderFns } from "./IncreaseNumber.vue?vue&type=template&id=46a2171c&"
import script from "./IncreaseNumber.vue?vue&type=script&lang=js&"
export * from "./IncreaseNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('46a2171c')) {
      api.createRecord('46a2171c', component.options)
    } else {
      api.reload('46a2171c', component.options)
    }
    module.hot.accept("./IncreaseNumber.vue?vue&type=template&id=46a2171c&", function () {
      api.rerender('46a2171c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2G5TlFMCfq87t/JS/IncreaseNumber.vue"
export default component.exports